import axios from "axios";

const UPLOAD_API_BASE_URL =
  process.env.REACT_APP_UPLOAD_API_URL || "http://localhost:3000";

/**
 * Upload a file to the REST upload API.
 * POST multipart/form-data with key "file". Returns imageUploadUrl for storage.
 * @param {File} file - The file to upload (image, video, or PDF)
 * @returns {Promise<{ imageUploadUrl: string, imageName: string, contentType: string, message: string }>}
 * @throws {Error} on network failure or when API returns error !== 0
 */
const uploadFile = async (file) => {
  const url = `${UPLOAD_API_BASE_URL}/uploadFile`;
  console.log("[uploadFile] request:", {
    url,
    fileName: file?.name,
    fileSize: file?.size,
    fileType: file?.type,
  });

  const formData = new FormData();
  formData.append("file", file);

  let response;
  try {
    response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (err) {
    console.log("[uploadFile] axios error:", {
      message: err?.message,
      status: err?.response?.status,
      data: err?.response?.data,
    });
    throw err;
  }

  const data = response.data;
  console.log("[uploadFile] response:", {
    status: response.status,
    data,
  });

  if (response.status !== 200 || (data.error !== undefined && data.error !== 0)) {
    const msg = data?.message || "Upload failed";
    throw new Error(msg);
  }

  return {
    imageUploadUrl: data.imageUploadUrl,
    imageName: data.imageName,
    contentType: data.contentType,
    message: data.message,
  };
};

const deleteImage = async (uri, data) => {
  const config = {
    headers: {
      "Content-Type": "video/*",
      "x-amz-acl": "public-read",
    },
  };
  const response = await axios.post(uri, data, config);
  return response;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  uploadFile,
  deleteImage,
};
